'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultIcon = function DefaultIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'defs',
            null,
            _react2.default.createElement('path', {
                id: 'a',
                d: 'M0 60h56V0H0z'
            })
        ),
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement(
                'mask',
                {
                    id: 'b',
                    fill: '#fff'
                },
                _react2.default.createElement('use', {
                    xlinkHref: '#a'
                })
            ),
            _react2.default.createElement('path', {
                d: 'M28 10.638v5.295l-2.447 2.33-.953 4.552L19.941 30l-3.176 4.25-2.435 7.307v4.235l1.8 5.612 8.47 6.564 7.624 1.271 6.988-2.647 5.612-5.188 2.117-6.142-.846-4.976-2.224-7.306-3.705-4.977H33.07l-1.376-1.8v-1.27l1.376-1.588-1.376-2.542 1.376-2.54-1.376-2.33 1.376-2.224-1.376-3.07H28z',
                fill: '#F7F7F8',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#FFCF3F',
                mask: 'url(#b)',
                d: 'M24.737 5.026L22.249 2.46V0l16.017.782v2.032L37.17 5.026z'
            }),
            _react2.default.createElement('path', {
                d: 'M34.067 24.375c-.772 0-1.4.63-1.4 1.406 0 .776.628 1.407 1.4 1.407H37.8c.772 0 1.4-.631 1.4-1.407 0-.775-.628-1.406-1.4-1.406h-3.733zm3.733 4.688h-3.733A3.278 3.278 0 0 1 30.8 25.78a3.278 3.278 0 0 1 3.267-3.281H37.8a3.278 3.278 0 0 1 3.267 3.281 3.278 3.278 0 0 1-3.267 3.282z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M34.067 19.688c-.772 0-1.4.63-1.4 1.406 0 .775.628 1.406 1.4 1.406h5.6c.772 0 1.4-.63 1.4-1.406 0-.776-.628-1.407-1.4-1.407h-5.6zm5.6 4.687h-5.6a3.278 3.278 0 0 1-3.267-3.281 3.278 3.278 0 0 1 3.267-3.282h5.6a3.278 3.278 0 0 1 3.266 3.282 3.278 3.278 0 0 1-3.266 3.281z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M34.067 15c-.772 0-1.4.63-1.4 1.406 0 .776.628 1.407 1.4 1.407H40.6c.772 0 1.4-.631 1.4-1.407 0-.775-.628-1.406-1.4-1.406h-6.533zm6.533 4.688h-6.533a3.278 3.278 0 0 1-3.267-3.282 3.278 3.278 0 0 1 3.267-3.281H40.6a3.278 3.278 0 0 1 3.267 3.281 3.278 3.278 0 0 1-3.267 3.282z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M39.667 15l-5.7-.006c-1.236-.132-2.312-1.067-2.832-1.936-.315-.526-.43-1.029-.335-1.468v-1.277h1.867l-.015 1.623c.129.342.802 1.09 1.473 1.189h5.542c.772 0 1.4-.63 1.4-1.406 0-.776-.628-1.406-1.4-1.406h-3.89V8.437h3.89a3.278 3.278 0 0 1 3.266 3.282A3.278 3.278 0 0 1 39.667 15',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                d: 'M24.653 20.625h-3.886V18.75h3.113l3.187-3.2V9.374h7c.772 0 1.4-.63 1.4-1.406V6.562h-9.93l-5.6 4.659H3.732V9.346h15.531l5.6-4.659h12.47V7.97a3.278 3.278 0 0 1-3.267 3.281h-5.134v5.076l-4.28 4.299zM22.049 27.881l-2.707-1.63H3.732v-1.876h16.126l3.151 1.899z',
                fill: '#3F5060',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#FFEDBB',
                mask: 'url(#b)',
                d: 'M0 26.294h1.867V24.42H0zM0 11.25h1.867V9.375H0z'
            }),
            _react2.default.createElement('path', {
                fill: '#3F5060',
                mask: 'url(#b)',
                d: 'M23.49 6.145l-2.023-3.049V0h16.8v2.812H36.4v-.937H23.333v.654l1.71 2.576zM30.395 60c-5.176 0-10.03-2.294-13.338-6.3a7.218 7.218 0 0 1-1.099-.96c-.83-.893-1.252-1.813-1.252-2.735a.534.534 0 0 0-.004-.067c-.175-.375-.337-.76-.485-1.15-.756-.83-1.15-1.84-1.15-2.9 0-.373.05-.746.154-1.11a16.756 16.756 0 0 1-.154-2.184c0-.835.25-1.647.722-2.347.097-.144.166-.344.21-.612.803-4.796 3.153-9.013 7.396-13.276a12.686 12.686 0 0 0 3.336-7.754c.008-.117.006-.163.002-.223a4.06 4.06 0 0 1-.011-.322h1.867c0 .098.003.155.007.204.008.126.014.224-.003.466a14.585 14.585 0 0 1-3.856 8.932c-4.032 4.05-6.152 7.83-6.897 12.283-.09.54-.255.983-.506 1.354-.262.389-.4.837-.4 1.295 0 .633.05 1.302.158 2.104l.023.17-.038.17c-.018.09-.032.15-.05.212a2.24 2.24 0 0 0-.094.638c0 .59.222 1.154.627 1.587.066.07.124.146.18.223l.175.3c.159.429.339.855.534 1.265l.064.137.019.15c.026.19.041.32.041.453 0 .54.407 1.09.749 1.457.257.278.562.538.903.774l.194.179c2.953 3.63 7.319 5.712 11.976 5.712 4.663 0 9.032-2.088 11.986-5.726l.2-.185c.334-.226.632-.48.887-.754.342-.366.749-.918.749-1.455 0-.136.015-.266.032-.396l.092-.345c.192-.406.372-.833.534-1.268l.14-.253c.092-.124.149-.198.214-.267.404-.434.627-.998.627-1.588 0-.213-.031-.427-.094-.636a2.065 2.065 0 0 1-.044-.186l-.03-.153.009-.215c.108-.802.159-1.47.159-2.104 0-.458-.139-.906-.4-1.295-.252-.371-.417-.814-.508-1.355-.744-4.45-2.864-8.231-6.874-12.26l1.32-1.325c4.244 4.263 6.594 8.481 7.396 13.276.045.268.113.468.21.612.473.7.722 1.512.722 2.347 0 .672-.048 1.368-.153 2.18a4.191 4.191 0 0 1-.978 3.983l-.015.021c-.15.397-.314.786-.489 1.16-.002.026-.004.046-.004.065 0 .924-.422 1.844-1.251 2.737-.32.345-.686.663-1.09.948C40.434 57.7 35.577 60 30.395 60'
            }),
            _react2.default.createElement('path', {
                fill: '#00D8C8',
                mask: 'url(#b)',
                d: 'M26.133 44.063H28v-1.876h-1.867zM29.867 44.063h1.866v-1.876h-1.866zM33.6 44.063h1.867v-1.876H33.6z'
            }),
            _react2.default.createElement('path', {
                d: 'M8.4 41.25a.937.937 0 0 0 0 1.875.937.937 0 0 0 0-1.875m0 3.75a2.81 2.81 0 0 1-2.8-2.813 2.81 2.81 0 0 1 2.8-2.812 2.81 2.81 0 0 1 2.8 2.813A2.81 2.81 0 0 1 8.4 45M7.525 37.5h1.867v-3.398H7.525zM7.525 32.227h1.867v-1.875H7.525zM47.6 14.063a.937.937 0 0 0 0 1.874.937.937 0 0 0 0-1.874m0 3.75A2.81 2.81 0 0 1 44.8 15a2.81 2.81 0 0 1 2.8-2.813A2.81 2.81 0 0 1 50.4 15a2.81 2.81 0 0 1-2.8 2.813M46.725 10.313h1.867V6.913h-1.867zM46.725 5.04h1.867V3.163h-1.867z',
                fill: '#FFCF3F',
                mask: 'url(#b)'
            }),
            _react2.default.createElement('path', {
                fill: '#A7F2EB',
                mask: 'url(#b)',
                d: 'M51.333 28.125H53.2V26.25h-1.867zM48.533 30.938H50.4v-1.875h-1.867zM54.133 30.938H56v-1.875h-1.867zM51.333 33.75H53.2v-1.875h-1.867z'
            })
        )
    );
};

DefaultIcon.defaultProps = {
    width: '56',
    height: '60',
    viewBox: '0 0 56 60',
    xmlns: 'http://www.w3.org/2000/svg',
    xmlnsXlink: 'http://www.w3.org/1999/xlink'
};

var ProfileIcon = function (_React$Component) {
    _inherits(ProfileIcon, _React$Component);

    function ProfileIcon() {
        _classCallCheck(this, ProfileIcon);

        return _possibleConstructorReturn(this, (ProfileIcon.__proto__ || Object.getPrototypeOf(ProfileIcon)).apply(this, arguments));
    }

    _createClass(ProfileIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                this.props,
                _react2.default.createElement(DefaultIcon, { fill: this.props.hover || this.props.active ? _colors.Colors.calmWhite : _colors.Colors.claimBlack, width: size + 'px', height: size + 'px' })
            );
        }
    }]);

    return ProfileIcon;
}(_react2.default.Component);

exports.default = ProfileIcon;